module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBold.bd3a3b8.ttf";